import request from '@/config/axios'
import type { InstallContext } from '@/store'

type ApiResponse<T> = {
  code: number
  data: T
  msg: string
}

type ResolveTerminalPayload = {
  regionId: number
  buildingId: number
  shaftId: number
}

type ResolveTerminalResp = {
  terminalId: number
}

type BindTerminalPayload = {
  terminalId: number
  terminalCode: string
}

const resolveRegionQrCode = (token: string) => {
  return request.get<ApiResponse<InstallContext>>({
    url: '/lift/install/region-qr/resolve',
    params: { token }
  })
}

const resolveTerminal = (data: ResolveTerminalPayload) => {
  return request.post<ApiResponse<ResolveTerminalResp>>({
    url: '/lift/install/terminal/resolve',
    data
  })
}

const bindTerminal = (data: BindTerminalPayload) => {
  return request.post<ApiResponse<boolean>>({
    url: '/lift/install/terminal/bind',
    data
  })
}

export { bindTerminal, resolveRegionQrCode, resolveTerminal }
